import { Component, OnInit } from '@angular/core';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { Chart, registerables } from 'chart.js';
import annotationPlugin from 'chartjs-plugin-annotation';
import { ActivatedRoute, Router } from '@angular/router';
import { HomeService } from '../home/home.service';
import { catchError, map } from 'rxjs/operators';
import { MeasureService } from '../measure/measure.service';
import { of } from 'rxjs';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-test-report',
  templateUrl: './test-report.component.html',
  styleUrls: ['./test-report.component.scss'],
})
export class TestReportComponent implements OnInit {
  type: string;
  mid: string;
  paid: string;
  view_status: string;
  access_id: string;
  informant_type: string;

  role = true;
  myrole;
  paymentcomplete = true;
  errorms;

  isInformant: boolean = false;
  report: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private homeService: HomeService,
    private measureService: MeasureService
  ) { }

  ngOnInit() {
    Chart.register(...registerables);
    Chart.register(annotationPlugin);

    this.route.queryParams.subscribe((params) => {
      this.type = params.type;
      this.mid = params.mid;
      this.paid = params.paid;
      this.view_status = params.view_status;
      this.access_id = params.access_id ? params.access_id : ''
      this.informant_type = params.informant_type;
    });

    let body

    if (this.access_id) {
      body = {
        MEASURE_ID: this.mid,
        TYPE_REPORT: this.paid,
        ACCESS_ID: this.access_id,
        INFORMANT_TYPE: this.informant_type,
      };
    } else {

      body = {
        MEASURE_ID: this.mid,
        TYPE_REPORT: this.paid,
        INFORMANT_TYPE: this.informant_type,
      };
    }
    // console.log(body);

    this.homeService
      .getRole()
      .pipe(
        map((res) => {
          this.role = res.result.ROLE;
          this.myrole = res.result.ROLE;
          // // console.log(this.role);
        })
      )
      .subscribe();

    this.measureService
      .getReportByMeasureId(body)
      .pipe(
        map((res) => {
          console.log(res);
          if (res.success) {
            console.log(res.result.data2);
            this.report = res.result;
          }
          this.paymentcomplete = true;
        }),
        catchError((err) => {
          this.paymentcomplete = false;
          alert(err.error.message);
          this.router.navigate(['/']);
          return of(null)
        })
      )
      .subscribe();
  }

  openLogin() {
    this.router.navigate(['login'], { state: { redirect: this.router.url } });
  }
}
